import script from "./SignatureModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignatureModal.vue?vue&type=script&setup=true&lang=ts"

import "./SignatureModal.vue?vue&type=style&index=0&id=e63711aa&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63711aa"]])

export default __exports__